
export enum documentTypeName {
    CONTRACT = 'contract',
    INVOICE = 'invoice',
    PAYMENT = 'payment',
    PROFILE_PICTURE = 'Profile picture',
    EVENT_IMAGE = 'Event image',
    IDENTITY_DOCUMENT = 'Proof of Identification',
    MATRIC_CERTIFICATE = 'Matric Certificate',
    FINANCIAL_STATEMENT = 'Financial Statement',
    ACADEMIC_RECORD = 'Academic Record'
  }
  